var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackAppendageBase5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 59 45",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M15 16h1M35 16h1M14 17h3M34 17h3M15 18h3M33 18h3M16 19h4M31 19h4M17 20h3M31 20h3M17 21h4M30 21h4M19 22h3M29 22h3M20 23h3M28 23h3M21 24h3M27 24h3M22 25h3M26 25h3M23 26h5M24 27h3M23 28h5M22 29h3M26 29h3M21 30h3M27 30h3M20 31h3M28 31h3M19 32h3M29 32h3M18 33h3M30 33h3M17 34h3M31 34h3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAppendageBase5);
export default __webpack_public_path__ + "static/media/back-appendage-base5.056b98d44f974bde5fcdc65d042e5987.svg";
export { ForwardRef as ReactComponent };